<template>
  <div class="project-cart-form">
    <form @submit.prevent="submit">
      <submit-button
        :loading="loading"
        :default-label="buttonDefaultLabel"
        :loading-label="buttonLoadingLabel"
      />
    </form>
    <div class="add-to-cart-notifications">
      <alert-box
        v-for="alert in alerts"
        :key="alert.message"
        :type="alert.type"
      >
        {{ alert.message }}
      </alert-box>
      <add-to-cart-modal
        ref="modal"
        :title="responseData.title"
        :variant="responseData.variant"
        :order="responseData.order"
        :continue-shopping-label="continueShoppingLabel"
        :cart-heading="modalCartHeading"
        :total-label="modalTotalLabel"
        :view-cart-label="viewCartLabel"
        :warnings="responseData.warnings"
      />
    </div>
  </div>
</template>

<script>
  import axios from "axios"
  import alerts from "mixins/storefront/cart-alerts"
  import updateCart from "mixins/storefront/update-cart"
  import SubmitButton from "./submit-button.vue"
  import AddToCartModal from "./add-to-cart/modal.vue"

  export default {
    components: {
      SubmitButton,
      AddToCartModal
    },
    mixins: [alerts, updateCart],
    props: {
      url: { type: String, required: true },
      projectItems: { type: Array, required: true },
      slug: { type: String, required: true },
      buttonDefaultLabel: { type: String, default: "Add Items to Cart" },
      buttonLoadingLabel: { type: String, default: "Adding items..." },
      modalCartHeading: { type: String, default: "Cart info" },
      modalTotalLabel: { type: String, default: "Order Subtotal" },
      continueShoppingLabel: { type: String, default: "Continue reading" },
      viewCartLabel: { type: String, default: "View Cart" }
    },
    data() {
      const variants = {}
      this.projectItems.forEach((item) => {
        variants[item.variantId] = item.quantity
      })

      return {
        loading: false,
        responseData: {
          variant: {},
          order: {}
        },
        variants
      }
    },
    methods: {
      submit() {
        this.alerts = []
        this.loading = true

        axios.post(this.url, { variants: this.variants })
          .then((response) => {
            this.loading = false

            switch (response.status) {
              case 200:
                this.responseData = response.data
                this.$refs.modal.open()
                this.updateCart(response.data.order)
                this.csTrack(response.data.items_added)
                break
              case 422:
                response.data.errors.forEach((error) => {
                  this.alert(error, "danger")
                })
                break
              default:
                break
            }
          })
          .catch((error) => {
            if (error.response && error.response.data) {
              error.response.data.errors.forEach((message) => {
                this.alert(message, "danger")
              })
            } else {
              this.alert(error.message || error, "danger")
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      csTrack(itemsAdded) {
        // GA Enhanced Ecommerce - Add to Cart
        // https://developers.google.com/tag-manager/enhanced-ecommerce#cart
        cs.dataLayer.push(
          {
            event: "addToCart",
            ecommerce: {
              add: {
                products: itemsAdded.map((item) => {
                  return {
                    id: item.variant.sku,
                    name: item.variant.product_name,
                    category: item.variant.ga_category,
                    variant: item.variant.name,
                    price: item.variant.price,
                    quantity: item.quantity
                  }
                })
              }
            }
          }
        )
      }
    }
  }
</script>
